import { z } from "zod";
import { AccessToken, RefreshToken } from "./branded.js";
export const ProviderCapabilitiesSchema = z.object({
    supportSubtasks: z.boolean(),
    supportRecurring: z.boolean(),
    supportReminders: z.boolean(),
    supportAttachments: z.boolean(),
    supportLabels: z.boolean(),
    supportCollaboration: z.boolean(),
    maxListsPerUser: z.number().optional(),
    maxTasksPerList: z.number().optional(),
});
export const OAuthTokensSchema = z.object({
    accessToken: z.string().transform((val) => AccessToken(val)),
    refreshToken: z.string().transform((val) => RefreshToken(val)),
    expiresAt: z.date(), // Access token expiration (typically 1 hour)
    refreshTokenExpiresAt: z.date().optional(), // Refresh token expiration (typically 90 days for Microsoft, 180 days for Google)
    scopes: z.array(z.string()),
});
//# sourceMappingURL=provider.js.map